// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index';
import ElementUI from 'element-ui'
import BaiduMap from '@/components/vue-baidu-map/components'
import 'element-ui/lib/theme-chalk/index.css'
// import echarts from 'echarts'
import './common/css/base.css'
import 'normalize.css/normalize.css'
import './utils/flexible'
// import '@/common/css/font.scss';
import * as filters from '@/common/filter/index.js';

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'So41LIbBgsBFgzR3x2sKaIX1NGqxHpx8'
})
let echarts = require('echarts')
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

//引入过滤器
Object.keys(filters).forEach(item => {
  Vue.filter(item,filters[item])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js